import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { allowedLangOptions } from '../config/header';
import { useLocation } from 'react-router-dom';
import { findMatchingRoute, liveRoutes, usePathReconstructor } from '../config/pageRoutes';

type Props = {
    isExpanded: boolean;
}

const SideHeaderLangSelector = (props: Props) => {
    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);
    const location = useLocation();
    const { replaceParam } = usePathReconstructor();

    function handleButtonClick() {
        setOpen((prevOpen) => !prevOpen);
    }

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    function handleClose(event: Event | React.SyntheticEvent) {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }
        setOpen(false);
    }

    function handleOptionChange(newLang: string) {
        const resultPath = findMatchingRoute(location.pathname, liveRoutes.map(route => route.path));
        i18n.changeLanguage(newLang);
        setOpen(false);
        const newURL = replaceParam("lang", newLang);
        window.history.pushState({}, '', newURL);
    }

    return (
        <div>
            {!props.isExpanded && (
                <div className="w-full text-center flex justify-end items-center p-2">
                    <button
                        onClick={handleButtonClick}
                        ref={anchorRef}
                        className="cursor-pointer rounded-full border-solid border-[2px] border-primary-light hover:border-secondary transition-all">
                        <img
                            className="w-[34px]"
                            src={`/assets/flags/${i18n.language}.png`}
                        />
                    </button>
                </div>
            )}
            {props.isExpanded && (
                <button
                    ref={anchorRef}
                    onClick={handleButtonClick}
                    className="bg-primary flex gap-4 items-center justify-start w-full py-1.5 px-2 rounded-[8px] hover:bg-primary-light transition-all mb-2">
                    <img
                        className="w-[34px]"
                        src={`/assets/flags/${i18n.language}.png`}
                    />
                    <span className="font-bold">
                        {allowedLangOptions.find(option => option.value === i18n.language)?.label || ""}
                    </span>
                </button>
            )}
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="top-start"
                transition
                disablePortal
                style={{ zIndex: 1000, textAlign: "center", }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                            marginLeft: "10px",
                            marginRight: "10px",
                        }}
                    >
                        <Paper
                            style={{ maxHeight: "360px", overflowY: "auto", }}
                        >
                            <ClickAwayListener onClickAway={handleClose}>
                                <div
                                    className=""
                                >
                                    <MenuList
                                        autoFocusItem={false}
                                        onKeyDown={handleListKeyDown}
                                    >
                                        {allowedLangOptions.map(option => {
                                            return <MenuItem
                                                key={option.value}
                                                onClick={() => handleOptionChange(option.value)}

                                            >
                                                <div className="flex gap-2">
                                                    <div>
                                                        <img
                                                            className="w-[25px]"
                                                            src={`/assets/flags/${option.value}.png`}
                                                        />
                                                    </div>
                                                    <div>
                                                        {option.label}
                                                    </div>
                                                </div>
                                            </MenuItem>
                                        })}
                                    </MenuList>
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    )
}

export default SideHeaderLangSelector